import { useEffect } from "react";

interface HelmetSeoProps {
  title: string;
  description: string;
}

const DESCRIPTION_SELECTOR = 'meta[name="description"]';

const HelmetSeo: React.FC<HelmetSeoProps> = ({ title, description }) => {
  useEffect(() => {
    if (title) {
      document.title = title;
    }

    let meta = document.querySelector<HTMLMetaElement>(DESCRIPTION_SELECTOR);
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = description || "";
  }, [title, description]);

  return null;
};

export default HelmetSeo;
